import ArtistNameList from './ArtistNameList';

export default ArtistNameList;
